import { render, staticRenderFns } from "./pagehead.vue?vue&type=template&id=4dec4cdf&scoped=true"
import script from "./pagehead.vue?vue&type=script&lang=js"
export * from "./pagehead.vue?vue&type=script&lang=js"
import style0 from "./pagehead.vue?vue&type=style&index=0&id=4dec4cdf&prod&lang=scss&scoped=true"
import style1 from "./pagehead.vue?vue&type=style&index=1&id=4dec4cdf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dec4cdf",
  null
  
)

export default component.exports